module.exports = __webpack_public_path__ + "img/footerlogo.d470d059.svg";